namespace MACRAIL.Validation {

     export class FileValidator implements IValidator {

        private opts: any;

        constructor (opts: any) {
            this.opts = opts;
        }

        public validate(value: any) {
            let opts = this.opts;

            let messages: IValidatorMessage[] = [];

            if (!value) {
                return messages;
            }

            if (opts.validExtensions !== undefined) {
                if (value.type !== undefined && opts.validExtensions.indexOf(value.type) === -1) {
                    messages.push({
                        'slug': 'file',
                        'status': 'error',
                        'message': opts.invalidMessage || 'File Type is not allowed',
                    });
                }
            }

            if (opts.invalidExtensions !== undefined) {
                if (value.type !== undefined && opts.validExtensions.indexOf(value.type) >= 0) {
                    messages.push({
                        'slug': 'file',
                        'status': 'error',
                        'message': opts.invalidMessage || 'File Type is not allowed',
                    });
                }
            }
            return messages;
        }
    }
}
